export const superAdminDeleteMessage = `
mutation SuperAdminDeleteMessage($input: inputSuperAdminDeletePPSubItem!) {
	superAdminDeleteMessage(input: $input){
		id
	}
}
`
